// extracted by mini-css-extract-plugin
export default {"loadingSpinner":"loading_loadingSpinner__PeqgY"};